import { SelectAsyncInput } from '@core/components/Select';
import cstApi from 'app/services/api/servicoFiscal/cstApi';
import React, { useEffect } from 'react';

const SelectCstClassificacaoTributaria = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  disabled,
  idSituacao,
  required = true,
}) => {
  const idState = React.useRef(null);

  useEffect(() => {
    if (idSituacao) {
      idState.current = idSituacao;
    }
  }, [idSituacao]);

  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await cstApi.pesquisarCstClassificacao({
          size: 200,
          sort: 'codigo',
          page: next,
          q: query,
        });

        let data = response?.data || [];

        if (idState.current) {
          data = data.filter((dataItem) => {
            return dataItem?.cstPaiId === idState.current;
          });
        }

        return { data };
      }}
      fetchOnFocus
      disabled={disabled}
      required={required}
    />
  );
};

export default SelectCstClassificacaoTributaria;
